import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { MegaMenu } from '@awaze/design-system.compositions.mega-menu';
import { getGaAttribute } from '../utils/ga-attribute';
import { NavigationItemText } from './navigation-item-text';
import { NavigationItemStyled } from './navigation-item.styles';
export const MegaMenuHoverWrapper = styled.div `
  opacity: 0;
  visibility: hidden;
  transition: opacity 150ms ease, visibility 150ms ease;
`;
export const ArrowElementWrapper = styled.div `
  position: relative;
`;
export const ArrowElement = styled.div `
  &::before {
    opacity: 0;
    visibility: hidden;
    transition: opacity 150ms ease, visibility 150ms ease;
    content: '';
    position: absolute;
    top: 30px;
    left: 50%;
    z-index: 10;
    transform: translateX(-50%);
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid #fff;
  }
`;
export const NavigationItemWithMegaMenuContainer = styled.div `
  &:hover ${MegaMenuHoverWrapper}, &:hover ${ArrowElement}::before {
    opacity: 1;
    visibility: visible;
  }
`;
export const NavigationItemWithMegaMenu = (props) => {
    const { highlight = false, isMobile, icon = null, megaMenu, isChild = false, link, linkPosition = 0, user, } = props;
    return (_jsxs(NavigationItemWithMegaMenuContainer, { "data-ga": getGaAttribute('navigationlink', link?.displayText ?? '', link?.href, linkPosition), children: [_jsx(NavigationItemStyled, { isChild: isChild, children: _jsx(NavigationItemText, { highlight,
                    isMobile,
                    link,
                    icon,
                    user, isDropdown: true }) }), _jsx(ArrowElementWrapper, { children: _jsx(ArrowElement, {}) }), _jsx(MegaMenuHoverWrapper, { children: _jsx(MegaMenu, { id: megaMenu.id, displayText: megaMenu.displayText, leftSection: megaMenu.leftSection, rightSection: megaMenu.rightSection, linkPosition: linkPosition }) })] }));
};
//# sourceMappingURL=navigation-item-with-mega-menu.js.map